import { render } from "./AproposVue.vue?vue&type=template&id=72fe5203&scoped=true"
const script = {}

import "../assets/css/propos.css?vue&type=style&index=0&id=72fe5203&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fe5203"]])

export default __exports__